<template>
	<v-main>
		<v-navigation-drawer fixed clipped permanent style="padding: 64px 0px 0px 0px;">
			<!-- <v-card class="mx-auto" elevation="0"> -->
			<v-card flat>
				<v-card-text>
					<v-form ref="form">
						<!-- <v-tabs v-model="params.tab" grow>
							<v-tabs-slider color="yellow"></v-tabs-slider>
							<v-tab tab-value="number">Номер</v-tab>
							<v-tab tab-value="vin">VIN</v-tab>
						</v-tabs>
						<v-tabs-items v-model="params.tab" class="pt-3">
							<v-tab-item value="number">
								<v-text-field
									label="Реєстраційний номер"
									v-model.trim="params.number"
									outlined
									dense
									clearable
									:rules="[rules.requiredNumber]"
									@keyup.ctrl.90="params.number='ab9999it'"
									hide-details="auto"
								></v-text-field>
							</v-tab-item>
							<v-tab-item value="vin">
								<v-text-field
									label="VIN-код"
									v-model.trim="params.vin"
									outlined
									dense
									clearable
									:rules="[rules.requiredVIN]"
									@keyup.ctrl.90="params.vin='WAUZZZ4M0HD001505'"
									hide-details="auto"
								></v-text-field>
							</v-tab-item>
						</v-tabs-items> -->

						<z-vehicle-number-vin
							v-model="params.numbervin"
							outlined
							dense
							clearable
							:rules="rules"
							default-vin="WAUZZZ4M0HD001505"
						></z-vehicle-number-vin>
					</v-form>
				</v-card-text>
			</v-card>
			<template v-slot:append>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
					<v-btn color="primary" @click="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
				</v-card-actions>
			</template>
		</v-navigation-drawer>

		<v-navigation-drawer fixed clipped permanent right
			mini-variant
			mini-variant-width="56"
			style="padding: 64px 0px 0px 0px;"
        >	
			<v-list dense nav>
				<!-- Favorit -->
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<!-- <v-icon v-if="isFavorit" color="yellow-darken-3" v-bind="attrs" v-on="{ ...tooltip }" @click="onFavorit">mdi-star</v-icon> -->
								<v-icon v-if="isFavorit" color="yellow-darken-1" v-bind="attrs" v-on="{ ...tooltip }" @click="onFavorit">mdi-star</v-icon>
            					<v-icon v-else class="opacity-30" v-bind="attrs" v-on="{ ...tooltip }" @click="onFavorit">mdi-star-outline</v-icon>
							</template>
							<span>Вибране</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>
				<!-- PDF -->
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<!-- <v-btn icon   v-bind="attrs" v-on="{ ...tooltip }" @click="onPDF">
									<v-icon>mdi-file-pdf-box</v-icon>
								</v-btn> -->
								<v-icon color="red" v-bind="attrs" v-on="{ ...tooltip }" @click="onPDF">mdi-file-pdf-box</v-icon>
							</template>
							<span>Експорт PDF</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>

				<!-- Excel -->
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<download-excel 
									:data="excel.data"
									:name="excel.name"
									:type="excel.type"
								>
									<v-icon color="green darken-2" :disabled="excel.disabled" v-bind="attrs" v-on="on">mdi-microsoft-excel</v-icon>
								</download-excel>
							</template>
							<span>Експорт Excel</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>
			</v-list>
        </v-navigation-drawer>

		<v-container style="padding: 64px 0px 0px 256px;">
			<v-card flat>
				<v-card-title class="font-weight-light">
					{{ title }} {{ id ? '№' + id: '' }}
				</v-card-title>

				<v-divider></v-divider>

				<v-card-text>
					<v-row>
						<v-col cols="12" md="8">
							<v-simple-table dense>
								<template v-slot:default>
									<thead>
										<tr>
											<th class="text-left" width="50%">Назва</th>
											<th class="text-left">Значення</th>
										</tr>
									</thead>
									<tbody>
										<!-- <tr v-for="item in registrations" :key="item.code">
											<td>{{ item.name }}</td>
											<td>{{ item.val }}</td> 
										</tr> -->
										<tr v-if="original.hasOwnProperty('digits')"><td>Номер</td><td>{{ original.digits }}</td></tr>
										<tr v-if="original.hasOwnProperty('vin')"><td>VIN</td><td>{{ original.vin }}</td></tr>
										<tr v-if="original.hasOwnProperty('region')"><td>Регіон</td><td>{{ original.region.name_ua }}</td></tr>
										<tr v-if="original.hasOwnProperty('vendor')"><td>Марка</td><td>{{ original.vendor }}</td></tr>
										<tr v-if="original.hasOwnProperty('model')"><td>Модель</td><td>{{ original.model }}</td></tr>
										<tr v-if="original.hasOwnProperty('model_year')"><td>Рік</td><td>{{ original.model_year }}</td></tr>
										<tr v-if="original.hasOwnProperty('notes')"><td>Примітки</td><td>{{ original.notes }}</td></tr>
										<tr v-if="original.hasOwnProperty('is_stolen')"><td>Ознака викрадення</td><td>{{ original.is_stolen ? 'ТАК' : 'НІ' }}</td></tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-col>
						<v-col cols="12" md="4">
							<v-img v-if="original.hasOwnProperty('photo_url')"
								:src="original.photo_url"
							></v-img>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>

			<!-- <v-divider></v-divider> -->

			<v-card flat v-for="(operation, index) in operations" :key="index">
				<!-- <v-card-title class="font-weight-light text-subtitle-1">Реєстрація {{ item.registered_at }}</v-card-title> -->
				<v-card-title class="font-weight-light text-subtitle-1">Реєстрація</v-card-title>
				<v-card-text>
					<v-simple-table dense>
						<template v-slot:default>
							<thead>
								<tr>
									<th class="text-left" width="30%">Назва</th>
									<th class="text-left">Значення</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in operation" :key="index">
									<td>{{ item.name }}</td>
									<td>{{ item.value }}</td>
								</tr>
								<!-- <tr v-if="item.hasOwnProperty('digits')"><td>Номер</td><td>{{ item.digits }}</td></tr>
								<tr v-if="item.hasOwnProperty('operation_group')"><td>Тип реєстрації</td><td>{{ item.operation_group.ua }}</td></tr>
								<tr v-if="item.hasOwnProperty('is_last')"><td>Остання реєстрація</td><td>{{ item.is_last? 'ТАК' : 'НІ' }}</td></tr>
								<tr v-if="item.hasOwnProperty('registered_at')"><td>Дата реєстрації</td><td>{{ item.registered_at }}</td></tr>
								
								<tr v-if="item.hasOwnProperty('catalog_model_title')"><td>catalog_model_title</td><td>{{ item.catalog_model_title }}</td></tr>
								<tr v-if="item.hasOwnProperty('catalog_model_slug')"><td>catalog_model_slug</td><td>{{ item.catalog_model_slug }}</td></tr>
								
								<tr v-if="item.hasOwnProperty('kind')"><td>Тип</td><td>{{ item.kind.ua }}</td></tr>
								<tr v-if="item.hasOwnProperty('vendor')"><td>Марка</td><td>{{ item.vendor }}</td></tr>
								<tr v-if="item.hasOwnProperty('model')"><td>Модель</td><td>{{ item.model }}</td></tr>
								<tr v-if="item.hasOwnProperty('model_year')"><td>Рік</td><td>{{ item.model_year }}</td></tr>
								<tr v-if="item.hasOwnProperty('body')"><td>Тип кузова</td><td>{{ item.body.ua }}</td></tr>
								<tr v-if="item.hasOwnProperty('purpose')"><td>Призначення</td><td>{{ item.purpose.ua }}</td></tr>
								<tr v-if="item.hasOwnProperty('color')"><td>Колір</td><td>{{ item.color.ua }}</td></tr>
								<tr v-if="item.hasOwnProperty('fuel')"><td>Тип палива</td><td>{{ item.fuel.ua }}</td></tr>
								<tr v-if="item.hasOwnProperty('own_weight')"><td>Власна вага</td><td>{{ item.own_weight }}</td></tr>
								<tr v-if="item.hasOwnProperty('total_weight')"><td>Загальна вага</td><td>{{ item.total_weight }}</td></tr>

								<tr v-if="item.hasOwnProperty('is_registered_to_company')"><td>Зареєстровано на організацію</td><td>{{ item.is_registered_to_company? 'ТАК' : 'НІ' }}</td></tr>
								<tr v-if="item.hasOwnProperty('department')"><td>Підрозділ</td><td>{{ item.department }}</td></tr>
								<tr v-if="item.hasOwnProperty('address')"><td>Адреса</td><td>{{ item.address }}</td></tr>
								<tr v-if="item.hasOwnProperty('koatuu')"><td>КОАТУУ</td><td>{{ item.koatuu }}</td></tr>
								<tr v-if="item.hasOwnProperty('displacement')"><td>displacement</td><td>{{ item.displacement }}</td></tr>
								<tr v-if="item.hasOwnProperty('operation')"><td>Коментар</td><td>{{ item.operation.ua }}</td></tr> -->
							</tbody>
						</template>
					</v-simple-table>
					<br>
					<v-divider></v-divider>
				</v-card-text>
			</v-card>

			<v-card flat v-if="stolen_details.length">
				<v-card-title class="font-weight-light text-subtitle-1">Інформація про викрадення</v-card-title>
				<v-card-text v-for="(item, index) in stolen_details" :key="index">
					<v-simple-table dense>
						<template v-slot:default>
							<thead>
								<tr>
									<th class="text-left" width="30%">Назва</th>
									<th class="text-left">Значення</th>
								</tr>
							</thead>
							<tbody>
								<tr v-if="item.hasOwnProperty('theft_at')"><td>Дата викрадення</td><td>{{ item.theft_at }}</td></tr>
								<tr v-if="item.hasOwnProperty('vendor_title')"><td>Тип реєстрації</td><td>{{ item.vendor_title }}</td></tr>
								<tr v-if="item.hasOwnProperty('color')"><td>Колір</td><td>{{ item.color.title.ua }}</td></tr>
								<tr v-if="item.hasOwnProperty('raw_color')"><td>Колір</td><td>{{ item.raw_color }}</td></tr>
								<tr v-if="item.hasOwnProperty('car_type')"><td>Тип</td><td>{{ item.car_type }}</td></tr>
								<tr v-if="item.hasOwnProperty('chassis_number')"><td>Номер шассі</td><td>{{ item.chassis_number }}</td></tr>
								<tr v-if="item.hasOwnProperty('body_number')"><td>Номер кузова</td><td>{{ item.body_number }}</td></tr>
								<tr v-if="item.hasOwnProperty('department_title')"><td>Підрозділ поліції</td><td>{{ item.department_title }}</td></tr>
							</tbody>
						</template>
					</v-simple-table>

					<v-divider></v-divider>
				</v-card-text>
			</v-card>

			<v-card flat v-if="comments.length">
				<v-card-title class="font-weight-light text-subtitle-1">Коментарі</v-card-title>
				<v-card-text>
					<v-simple-table dense>
						<template v-slot:default>
							<thead>
								<tr>
									<th class="text-left" width="10%">ID</th>
									<th class="text-left" width="20%">Назва</th>
									<th class="text-left">Текст</th>
									<th class="text-left" width="10%">Створено</th>
									<th class="text-left" width="10%">Змінено</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="item in comments" :key="index">
									<td>{{ item.id }}</td>
									<td>{{ item.name }}</td>
									<td>{{ item.text }}</td>
									<td>{{ item.created_at | formatDate }}</td>
									<td>{{ item.updated_at | formatDate }}</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>

					<v-divider></v-divider>
				</v-card-text>
			</v-card>

			<!-- <v-divider></v-divider> -->

			<div class="text-caption text-right font-weight-light" v-if="item.hasOwnProperty('x_ratelimit_remaining')">Залишилось запитів: {{ item.x_ratelimit_remaining }}</div>
		</v-container>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>

		<v-snackbar v-model="snackbar.visible" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
			<v-btn icon v-bind="attrs" @click="snackbar.visible = false" >
				<v-icon>mdi-close</v-icon>
			</v-btn>
			</template>
		</v-snackbar>

		<z-pdf ref="pdf"
			:item="item"
		></z-pdf>
	</v-main>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import axios from 'axios'
import mixin from './mixin/parameters'
import downloadExcel from "vue-json-excel"
//import zVehicleParametersNumber from '@/views/forms/vehicle.parameters.number'
import zPdf from '@/views/pdf/VehicleEstimate'
import zVehicleNumberVin from '@/views/components/control/VehicleNumberVin'

export default {
	name: 'BazaDai',
	mixins: [mixin],
	components: {
		zPdf,
		downloadExcel,
		zVehicleNumberVin,
		//zVehicleParametersNumber,
	},
	data: () => ({
		title: 'Інформація з єдиного державного реєстру транспортних засобів',
		loading: false,

		excel: {
			name: '',
			type: 'xlsx',
			disabled: true,
			data: []
		},

		snackbar: {
			visible: false,
			text: null,
			color: null
		},
	}),
	
	watch: {
		/* tab(val) {
			console.log(this.$options.name, 'tab','val', val)
		} */
	},

	computed: {
		...mapGetters('BazaDai', [ 'item' ]),

		code() {
			return `${this.$options.name}:${this.item.digits}:${this.item.vin}`
		},

		excelName() {
			return this.title + (this.params.regnum ? ' ' + this.params.regnum : (this.params.vin ? ' ' + this.params.vin : '') + '.' +  this.excelType)
		},

		id() {
			return this.item.hasOwnProperty('id') ? this.item.id: null;
		},


		// Дані про державну реєстрацію транспортного засобу
		registrations() {
			let results = []
			
			return results
			//return this.item.hasOwnProperty('registrations') ? this.item.registrations: [];
		},

		operations() {
			return this.item?.operations ? this.item.operations: [];
		},

		original() {
			return this.item?.original ? this.item.original : {};
		},

		stolen_details() {
			return this.item?.original?.stolen_details ? this.item.original.stolen_details: [];
		},

		comments() {
			return this.item?.original?.comments ? this.item.original.comments: [];
		},
	},

	methods: {
		...mapActions('VehicleParam', [ 'addFavorit', 'removeFavorit' ]),
		...mapActions('BazaDai', [ 'setItem' ]),

		onClear() {
			this.$refs.form.reset()
		},

		onOK() {
			var that = this
			if (this.$refs.form.validate()) {
				//console.log(this.$options.name, 'onOK', 'VALID')
				this.loading = true

				//let endpoint = this.params.tab == 'number' ? `/bazadai/number/${this.params.number}` : `/bazadai/vin/${this.params.vin}`;

				let endpoint = `/bazadai/${this.params.numbervin}`

				axios.get(endpoint).then(response => {
					//console.log(that.$options.name, 'onOK','response', response)
					//console.log(that.$options.name, 'onOK','response.data', response.data)

					that.setItem(response.data)
				}, error => {
					console.log('error', error)

					that.snackbar.visible 	= true;
					that.snackbar.text 		= error.response.data.message;
					that.snackbar.color 	= null;
				}).finally(() => {
					this.loading = false
					//console.log(this.$options.name, 'onOK','item', this.item)
				});
			}
		},

		onFavorit() {
			if(this.favorit) {
				this.removeFavorit(this.favorit) 
			} else {
				if(this.item?.favorit) {
					//console.log(this.$options.name, 'onFavorit','favorit', this.item.favorit)

					this.addFavorit({...this.item.favorit})
				}
			}
		},

		onPDF () {
			this.$refs.pdf.generate()
		}
	},
}
</script>